import React, { FC } from "react";
import { CardMedia, makeStyles } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Step } from "../types/Step";
import { backToStep } from "../store/engine/engineReducer";

const useStyles = makeStyles((theme) => ({
  root: {
    height: 80,
    width: 80,
    cursor: "pointer",
    [theme.breakpoints.down("sm")]: {
      height: 55,
      width: 55,
    },
  },
}));

export const AragLogo: FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const onClickLogo = () => {
    dispatch(backToStep(Step.COSA, history));
  };

  return <CardMedia image="assets/logo.png" title="ARAG" className={classes.root} onClick={onClickLogo} />;
};
